import * as types from '../../actions/types';

const initialState = {
  years: null,
  terms: null,
  groups: null,
  disciplines: null
}

export default function data (state = initialState, action) {
  switch (action.type) {
    case types.SET_JOURNAL_FILTERS:
      return {...state, ...action.payload};
    
    default:
      return state;
  }
}
